export default __webpack_public_path__ + "static/media/did_verification_img.541df926.png";